import { ListboxButton, useListboxContext } from '@reach/listbox';
import * as React from 'react';
import { createComponent } from '../core/create-component.js';
import { useSwanListboxContext } from './listbox.context.js';
const ListboxButtonWithLabel = createComponent({
  displayName: 'ListboxButtonWithLabel',
  root: ListboxButton,
  propConfig: {
    classNames: ['swan-listbox-button-with-label'],
    derivedProps() {
      const {
        valueLabel,
        value
      } = useListboxContext();
      const {
        labelMap
      } = useSwanListboxContext();
      return {
        valueLabel,
        value,
        labelMap
      };
    },
    wrapChildren(_props, derivedProps, element) {
      const {
        labelMap,
        value,
        valueLabel
      } = derivedProps;
      return /*#__PURE__*/React.createElement(React.Fragment, null, element, /*#__PURE__*/React.createElement("span", {
        className: "swan-listbox-button-with-label-container"
      }, value !== null && labelMap[value] || valueLabel || value));
    }
  }
});
export { ListboxButtonWithLabel };